import type { TFunction } from "i18next";
import type { TemplateContentDto } from "../../autogen/bff-api";
import type { ProcurementTerms } from "../terminology/useProcurementTerms";

/**
 * One-line description of what a template carries, shown both in the template list and in the
 * "Apply template" picker.
 *
 * A template whose award section was never filled in is distinct from one that deliberately says
 * "lowest price": the former leaves the procurement's award model alone when applied, so it must not
 * be summarised as if it prescribed one.
 */
export const templateSummary = (content: TemplateContentDto, t: TFunction, terms: ProcurementTerms): string => {
  const parts = [
    t("{{count}} minimum requirements", { count: content.minimumRequirements?.length ?? 0 }),
    t("{{count}} qualification requirements", { count: content.selectionCriteria?.length ?? 0 }),
  ];

  if (content.awardCriteria?.bestPriceQualityRatio) {
    parts.push(
      terms.awardCriteriaCount(content.awardCriteria.bestPriceQualityRatio.criteria?.length ?? 0)
    );
  } else if (content.awardCriteria?.lowestPrice) {
    parts.push(t("Lowest price"));
  } else {
    parts.push(t("No award section"));
  }

  return parts.join(" · ");
};
